import { Dimension } from '../types/geo.types';

declare var dataURLtoBlob;

export class ImageUtils {
    public static createEmptyImage(dimension: Dimension, color: string): Promise<HTMLImageElement> {
        const canvas = document.createElement('canvas');
        canvas.width = dimension.width;
        canvas.height = dimension.height;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = color;
        ctx.fillRect(0, 0, dimension.width, dimension.height);
        const dataUrl = canvas.toDataURL('image/jpeg', 100);

        return new Promise((resolve, reject) => {
            try {
                const image = new Image();
                image.onload = () => {
                    resolve(image);
                };
                image.src = URL.createObjectURL(dataURLtoBlob(dataUrl));
            } catch (e) {
                reject();
            }
        });
    }

    public static createImageSource(dimension: Dimension, color: string): string {
        const canvas = document.createElement('canvas');
        canvas.width = dimension.width;
        canvas.height = dimension.height;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = color;
        ctx.fillRect(0, 0, dimension.width, dimension.height);
        const dataUrl = canvas.toDataURL('image/jpeg', 100);
        return URL.createObjectURL(dataURLtoBlob(dataUrl));
    }
    //

    public static createImageSrcFromSVG(svgPath: string): Promise<string> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, img.width, img.height);
                const dataUrl = canvas.toDataURL('image/png', 100);
                resolve(URL.createObjectURL(dataURLtoBlob(dataUrl)));
            };
            img.src = svgPath;
        });
    }

    public static createImageFromSVG(svgPath: string): Promise<HTMLImageElement> {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                resolve(img);
            };
            ImageUtils.createImageSrcFromSVG(svgPath).then(blobUrl => img.src = blobUrl);
        });
    }

    public static createImageFromSource(imgUrl: string): Promise<string> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, img.width, img.height);
                const dataUrl = canvas.toDataURL('image/png', 100);
                resolve(URL.createObjectURL(dataURLtoBlob(dataUrl)));
            };
            img.src = imgUrl;
        });
    }

    public static createImage(imgUrl: string): Promise<HTMLImageElement> {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                resolve(img);
            };
            ImageUtils.createImageFromSource(imgUrl).then(blobUrl => img.src = blobUrl);
        });
    }

}
